import React, { FC } from 'react'
import { Grid } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import cx from 'classnames'
import { CustomFade } from 'components'
import useStyles from './password-complexity-requirement-style'
import { getPasswordRequirementComplexity } from 'utils'

interface IProps {
  passwordPolicyComplexity: any
  newPassword: string
}

const PasswordComplexityRequirement: FC<IProps> = ({
  passwordPolicyComplexity,
  newPassword,
}) => {
  const { classes } = useStyles()

  const { isPasswordComplex, passwordComplexityInfo } =
    getPasswordRequirementComplexity(passwordPolicyComplexity, newPassword)

  return !isPasswordComplex ? (
    <CustomFade>
      <ul className={classes.passwordComplexity}>
        {passwordComplexityInfo.map((value: any, i: number) => (
          <li key={i} className={cx(value.isActiveClass && 'active')}>
            {value.isActiveClass && (
              <CustomFade>
                <CheckCircleRoundedIcon />
              </CustomFade>
            )}
            {value.item}
          </li>
        ))}
      </ul>
    </CustomFade>
  ) : (
    <CustomFade>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        className={classes.securePasswordContainer}
      >
        <Grid item xs={1}>
          <CheckCircleRoundedIcon />
        </Grid>
        <Grid item xs={11}>
          <p>Your password is secure. Please confirm it below.</p>
        </Grid>
      </Grid>
    </CustomFade>
  )
}

export default PasswordComplexityRequirement
